/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getBoundsFromMap
 */

import type { MapInstance } from '@vis.gl/react-mapbox'
import { chomp, isValidBounds } from '@zcode/nr-utils'
import { isNumber } from '@zcode/utils'

export const getBoundsFromMap = (mapBox?: MapInstance, precision?: number) => {
  if (mapBox?.getBounds) {
    const bounds = mapBox.getBounds()
    const hasValidPrecision = isNumber(precision)

    if (!bounds) {
      return null
    }

    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()

    const box = {
      maxLat: hasValidPrecision ? chomp(ne.lat, precision) : ne.lat,
      maxLng: hasValidPrecision ? chomp(ne.lng, precision) : ne.lng,
      minLat: hasValidPrecision ? chomp(sw.lat, precision) : sw.lat,
      minLng: hasValidPrecision ? chomp(sw.lng, precision) : sw.lng,
    }

    if (isValidBounds(box)) {
      return box
    }
  }

  return null
}
